exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1RbQzHrlFatKytZWM5ntA_ {\n  padding-right: 20px;\n  padding-bottom: 40px;\n}\n", ""]);

// Exports
exports.locals = {
	"appSwitcher": "_1RbQzHrlFatKytZWM5ntA_"
};